import { render, staticRenderFns } from "./EventosActuales.vue?vue&type=template&id=02d95380&scoped=true"
import script from "./EventosActuales.vue?vue&type=script&lang=js"
export * from "./EventosActuales.vue?vue&type=script&lang=js"
import style0 from "./EventosActuales.vue?vue&type=style&index=0&id=02d95380&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d95380",
  null
  
)

export default component.exports